import React, { FC } from "react";
import { InputPassword, InputWrapper } from "./elements";
import { TextInputProps } from "./types";

const PasswordInput: FC<TextInputProps> = (props) => {
  const { placeholder, onChange, value, disabled, visibilityToggle, $error } = props;

  return (
    <InputWrapper>
      <InputPassword
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        disabled={disabled}
        visibilityToggle={visibilityToggle}
        $error={$error}
      />
    </InputWrapper>
  );
};

export default PasswordInput;
